// user.reducer.js
import { useReducer } from "react";
import * as ACTION from "./types";

const initialState = {
  isLoading: false,
  deviceId: null,
};

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case ACTION.UPDATE_LOADER:
      return {
        ...state,
        isLoading: action.payload,
      };
    case ACTION.UPDATE_DEVICE_ID:
      return {
        ...state,
        deviceId: action.payload,
      };
    default:
      return state;
  }
};

const useAppReducer = () => {
  const [state, dispatch] = useReducer(reducer, initialState);

  return {
    state,
    dispatch,
  };
};

export default useAppReducer;
